export type MsgInput = any[] | string;

export enum LogType {
  All = 'All',
  Info = 'Info',
  Warn = 'Warn',
  Error = 'Error',
}

export enum LogArea {
  All = 'All',
  Logger = 'Logger',
  Dev = 'Dev',
  Api = 'Api',
  Security = 'Security',
  Redux = 'Redux',
  Localization = 'Localization',
  Feedback = 'Feedback',
  ReadRights = 'ReadRights',
  Download = 'Download',
}
